<script setup>
import { useI18n } from 'vue-i18n';
import urlLinks from '@/plugins/linkUrl';

import '@sapudex/web-components/dist/MessageStrip.js';

const { t } = useI18n();
const SAP_COM_MAIN_PAGE_LINK = urlLinks.SAP_COM_MAIN_PAGE;

</script>

<template>
  <udex-message-strip design="Negative" status-type="Icon" :hide-close-button="true">
    {{ t("contact.me.send.fail") }} {{ t("contact.me.send.fail.please.access") }} <i>{{ t("contact.me.send.fail.contact.us") }}</i>
    <udex-link class="email-send-fail-contact" :href="SAP_COM_MAIN_PAGE_LINK" >
      {{ t("contact.me.send.fail.sap.com") }}
    </udex-link>
    {{ t("contact.me.send.fail.support") }}
  </udex-message-strip>
</template>
